import { render, staticRenderFns } from "./EmployeesSliceDelete.vue?vue&type=template&id=61160017&scoped=true&"
import script from "./EmployeesSliceDelete.vue?vue&type=script&lang=js&"
export * from "./EmployeesSliceDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61160017",
  null
  
)

export default component.exports